import { teamDetail, saveTeamLeader, memberDetail, saveMem, toAudit, saveCapitalAndCouch, editMember} from '@/api/team'
const state = { }
const mutations = { }
const actions = {
    saveTeam({commit,dispatch},params){
        return new Promise((resolve, reject) => {
            saveTeamLeader(params).then(res=>{
                resolve(res)
            })
        })
    },
    team({ commit, dispatch }, params) {
        return new Promise((resolve, reject) => {
            teamDetail(params).then(res => {
                resolve(res)
            })
        })
    },
    saveMem({ commit, dispatch }, params) {
        return new Promise((resolve, reject) => {
            saveMem(params).then(res => {
                resolve(res)
            })
        })
    },
    editMember({commit,dispatch},params){
        return new Promise((resolve, reject) => {
            editMember(params).then(res => {
                resolve(res)
            })
        })
    },
    toAudit({},params){
        return new Promise((resolve, reject) => {
            toAudit(params).then(res => {
                resolve(res)
            })
        })
    },
    saveCapitalAndCouch({},params){
        return new Promise((resolve, reject) => {
            saveCapitalAndCouch(params).then(res => {
                resolve(res)
            })
        })
    }
}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/team.js